import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  navlink: {
    textDecoration: 'none',
    color: 'inherit',
    '& hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& focus': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& link': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& visited': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& active': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
}));
